const NS = 'CaldLanguageModal';
const CLS = 'caldLanguageModal';

export class CaldLanguageModal {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$modal = this.$element.find(`#${CLS}`);
		this.show = this.$element.data('show');
		this.init();
	}

	showModal() {
		this.$modal.modal();
	}

	hideModal() {
		this.$modal.modal("hide");
	}

	listenHideModal() {
		$(`#${CLS}`).on('hide.bs.modal', () => {
			$(`#${CLS}`).remove();
		});
	}

	// Add open/close event on trigger point
	addTriggerEvent() {
		this.$element.find(`.${CLS}-triggerBtn`).on('click', () => {
			console.log('submit');
			this.showModal();
			return false;
		});
	}

	// Add close popup event on button click
	addButtonEvent() {
		this.$element.find(`.${CLS}-btn[data-action="back"]`).on('click', (event) => {
			event.preventDefault();
			this.hideModal();
		});
	}

	init() {
		this.addTriggerEvent();
		this.addButtonEvent();

		if(this.show === true) {
			this.$modal.modal();
		}

	}
}
